export default __webpack_public_path__ + "static/media/education.6dec2dd8.png";